import axios from 'axios'

export const ssoApiUrl = 'https://sso.zhuyilink.com'  // https://sso.zhuyilink.com
export const fileApiUrl = 'https://img.zhuyilink.com'

// const mode = 'debug';
// const apiConfig = {
//     debug: {
//         apiUrl: 'http://192.168.50.99:37117'
//     },
//     production: {
//         apiUrl: 'https://h5.zhuyilink.com',
//     }
// }

// 创建axios实例
const service = axios.create({
  // baseURL: apiConfig[mode].apiUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'X-Csrf-Token': 'csrfTokenValue',
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么

    return config
  },
  error => {
    debugger;
    // 对请求错误做些什么
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 0 || res.servedCode === 0) {
      return res
    } else {
      // 非200 code提示错误
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    console.log('err' + error) // for debug
    debugger;
    return Promise.reject(error)
  }
)

// 封装GET请求
export function get(url, params) {
  return service.get(url, {
    params
  })
}

// 封装POST请求
export function post(url, data, config) {
  return service.post(url, data, config)
}

// 封装PUT请求
export function put(url, data) {
  return service.put(url, data)
}

// 封装DELETE请求
export function del(url) {
  return service.delete(url)
}

export default service
